import { utilTool } from '@/common/utils';
import format from '@/common/format/date-format';
export const INPUT_FIELD_MAP = function() {
    let hasUser = !!this.user;
    let hasUserPhone = !!this.user?.phoneNumber;
    return [
        {
            name: 'fullname',
            tag: 'input',
            type: 'text',
            readonly: hasUser,
            defaultValue: '',
            nameType: 1,
            maxlength: 30,
            title: this.$t('md-form.titleOfName'),
            placeholder: this.$t('md-form.titleOfName'),
            firstNameTitle: 'First Name',
            lastNameTitle: 'Last Name',
            validateConfig: {},
            value: this.user?.fullName || '',
            required: true
        },
        {
            name: 'email',
            tag: 'input',
            type: 'email',
            readonly: hasUser,
            defaultValue: '',
            maxlength: 30,
            title: this.$t('md-form.titleOfEmail'),
            placeholder: this.$t('md-form.titleOfEmail'),
            validateConfig: {
                async: '/api-site/register/hasUser?account={value}',
                'async-callback': this.hasUserCallBack
            },
            value: this.user?.account || '',
            required: true
        },
        {
            name: 'phone',
            tag: 'input',
            type: 'tel',
            readonly: hasUserPhone,
            defaultValue: '',
            maxlength: 12,
            title: this.$t('md-form.titleOfPhone'),
            placeholder: this.$t('md-form.titleOfPhone'),
            validateConfig: {
                async: '/api-site/phoneValidate?phoneNumber={value}'
            },
            value: this.$ft.formatPhone(this.user?.phoneNumber || ''),
            required: false
        },
        {
            name: 'question',
            tag: 'textarea',
            type: 'text',
            readonly: false,
            title: this.$t('md-form.titleOfMsg'),
            placeholder: this.$t('md-form.titleOfMsg'),
            defaultValue: '',
            validateConfig: {},
            value: '',
            required: false
        }
    ];
};
const capitalFirstLetter = function(str) {
    if (!str) {
        return;
    }
    let letter_arr = str.split('');
    // capitalized 
    letter_arr.splice(0, 1, letter_arr[0].toUpperCase());
    // handle hump 
    return letter_arr
        .join('')
        .match(/[A-Z][a-z]+/g)
        .join(' ');
};
const formatTimeStampStr = function(str) {
    return str.replace(/(\d{13,13})/g, function(match) {
        let date = new Date(Number(match));
        return format('yyyy-MM-dd', date, this.$pinia);
    });
};

export const formatSearchCondition = function({ obj, result = '', map }) {
    let queue = Object.entries(obj);
    let arr = [];
    queue.map(([key, val]) => {
        if (utilTool.isArray(val)) {
            arr.push(
                `${map[key]?.label ?? capitalFirstLetter(key)}: ${val.join(
                    ','
                )}`
            );
            return;
        }
        if (utilTool.isObject(val)) {
            let res = formatSearchCondition({ obj: val, result, map });
            arr.push(`${res}`);
            return;
        }
        if (typeof val === 'boolean') {
            arr.push(`${map[key]?.label ?? capitalFirstLetter(key)}`);
            return;
        }
        // Handling Timestamp Strings 
        val = formatTimeStampStr.call(this, val);
        // If there is no placeholder, it is judged as a normal string 
        let minTag = map[key]?.mask?.minTag
            ? map[key].mask.minTag.includes('#min_value#')
                ? map[key].mask.minTag
                : 'More Than #min_value#'
            : '';
        let maxTag = map[key]?.mask?.maxTag
            ? map[key].mask.maxTag.includes('#max_value#')
                ? map[key].mask.maxTag
                : 'Less Than #max_value#'
            : '';
        let [min = '', max = ''] = val.split(',');
        let place = /#(min_value|max_value)#/;

        let minText = '';
        let maxText = '';
        // By default, the configuration label， Otherwise format manually 
        let label = map[key]?.label ?? capitalFirstLetter(key);
        if (min) {
            if (minTag.search(place) >= 0) {
                // a string containing placeholders 
                minText = minTag.replace(place, min);
            } else {
                // normal string 
                minText = `${min}`;
            }
            arr.push(`${label}: ${minText}`);
        }
        if (max) {
            if (maxTag.search(place) >= 0) {
                maxText = maxTag.replace(place, max);
            } else {
                maxText = `${max}`;
            }
            arr.push(`${label}: ${maxText}`);
        }
    });
    return arr.join(';\n');
};
